export default {
    namespaced: true,
    actions: {
        createNotification({ commit }, params) {
            return new Promise(resolve => {
                params.resolve = resolve
                commit('createNotification', params)
            })
        },
        setNotification({ commit }, params) {
            commit('setNotification', params)
        },
    },
    getters: {
        getNotification(state) {
            return state.notification
        },
    },
    mutations: {
        createNotification(state, params) {
            params.visible = true
            state.notification = params
        },
        setNotification(state, params) {
            state.notification = Object.assign({}, state.notification, params)
        },
    },
    state: {
        notification: {
            type: null,
            title: null,
            message: null,
            color: null,
            visible: false,
            loading: false,
            large: false,
        },
    },
}